import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { createLink } from '@src/util/createLink';
import { FUNNEL_ROUTE } from '@src/Routes/links';
import { ActiveView } from '@src/views/Opening/enums/activeView.enum';
import { ApplicantCountsProps } from './props';
import './styles.scss';

export const ApplicantCounts: FC<ApplicantCountsProps> = ({
  recommended,
  pending,
  inConversation,
  openingId,
  totalShortlist,
  unreadInConversation,
  unreadShortlistApplicants,
}) => {
  return (
    <div className="opening-item-applicant-counts">
      <div className="opening-item-applicant-counts__section">
        <div className="opening-item-applicant-counts__section-count">{recommended}</div>

        <Link
          className="opening-item-applicant-counts__section-link"
          to={createLink(FUNNEL_ROUTE, {
            params: { openingId },
            queryParams: { activeView: ActiveView.INVITE_CANDIDATES },
          })}
        >
          Invite candidates
        </Link>
      </div>

      <div className="opening-item-applicant-counts__section">
        <div className="opening-item-applicant-counts__section-count">{pending}</div>

        <Link
          className="opening-item-applicant-counts__section-link"
          to={createLink(FUNNEL_ROUTE, {
            params: { openingId },
            queryParams: { activeView: ActiveView.PENDING_INVITES },
          })}
        >
          Pending invites
        </Link>
      </div>

      <div className="opening-item-applicant-counts__section">
        <div className="opening-item-applicant-counts__section-count">{totalShortlist}</div>

        <Link
          className="opening-item-applicant-counts__section-link"
          to={createLink(FUNNEL_ROUTE, {
            params: { openingId },
            queryParams: { activeView: ActiveView.IN_SHORTLIST },
          })}
        >
          In shortlist
        </Link>

        {!!unreadShortlistApplicants && (
          <div className="opening-item-applicant-counts__unread-count">{unreadShortlistApplicants}</div>
        )}
      </div>

      <div className="opening-item-applicant-counts__section">
        <div className="opening-item-applicant-counts__section-count">{inConversation}</div>

        <Link
          className="opening-item-applicant-counts__section-link"
          to={createLink(FUNNEL_ROUTE, {
            params: { openingId },
            queryParams: { activeView: ActiveView.IN_CONVERSATION },
          })}
        >
          In conversation
        </Link>

        {!!unreadInConversation && (
          <div className="opening-item-applicant-counts__unread-count">{unreadInConversation}</div>
        )}
      </div>
    </div>
  );
};
